module.exports = __webpack_public_path__ + "static/media/varejo-4.be8f20b8.jpg";